import { Injectable } from '@angular/core';
import { Observable, Subject, EMPTY } from 'rxjs';
import { mergeMap, finalize, tap, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RequestQueueService {
  private readonly MAX_CONCURRENT = 2;
  private queue$ = new Subject<() => Observable<any>>();
  private activeCount = 0;
  private loadingSubject = new Subject<boolean>();
  loading$ = this.loadingSubject.asObservable();

  constructor() {
    this.queue$
      .pipe(
        mergeMap(factory => {
          this.activeCount++;
          this.loadingSubject.next(true);
          return factory().pipe(
            finalize(() => {
              this.activeCount--;
              this.loadingSubject.next(this.activeCount > 0);
            })
          );
        }, this.MAX_CONCURRENT)
      )
      .subscribe();
  }

  queueRequest<T>(factory: () => Observable<T>): Observable<T> {
    return new Observable<T>(observer => {
      this.queue$.next(() =>
        factory().pipe(
          tap(value => observer.next(value)),
          catchError(err => {
            observer.error(err);
            return EMPTY;
          }),
          finalize(() => observer.complete())
        )
      );
    });
  }
}
